// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { getParentProduct } from './getParentProduct.tsx';

export const useParentProduct = (): 'JSM' | 'JSW' | 'JWM' => {
	const { data } = useProjectContext();
	const projectType = data?.projectType;
	return getParentProduct(projectType);
};
